/*!
 * stack.js - stack object for bcoin
 * Copyright (c) 2014-2015, Fedor Indutny (MIT License)
 * Copyright (c) 2014-2017, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcoin
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var assert = require('bsert');

var common = require('./common');

var ScriptNum = require('./scriptnum');

var _require = require('../utils'),
    inspectSymbol = _require.inspectSymbol;
/**
 * Stack
 * Represents the stack of a Script during execution.
 * @alias module:script.Stack
 * @property {Buffer[]} items - Stack items.
 * @property {Number} length - Size of stack.
 */


var Stack = /*#__PURE__*/function () {
  /**
   * Create a stack.
   * @constructor
   * @param {Buffer[]?} items - Stack items.
   */
  function Stack(items) {
    _classCallCheck(this, Stack);

    this.items = items || [];
  }
  /**
   * Get length.
   * @returns {Number}
   */


  _createClass(Stack, [{
    key: Symbol.iterator,

    /**
     * Instantiate a value-only iterator.
     * @returns {StackIterator}
     */
    value: function value() {
      return this.items[Symbol.iterator]();
    }
    /**
     * Instantiate a value-only iterator.
     * @returns {StackIterator}
     */

  }, {
    key: "values",
    value: function values() {
      return this.items.values();
    }
    /**
     * Instantiate a key and value iterator.
     * @returns {StackIterator}
     */

  }, {
    key: "entries",
    value: function entries() {
      return this.items.entries();
    }
    /**
     * Inspect the stack.
     * @returns {String} Human-readable stack.
     */

  }, {
    key: inspectSymbol,
    value: function value() {
      return "<Stack: ".concat(this.toString(), ">");
    }
    /**
     * Convert the stack to a string.
     * @returns {String} Human-readable stack.
     */

  }, {
    key: "toString",
    value: function toString() {
      var out = [];

      var _iterator = _createForOfIteratorHelper(this.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          out.push(item.toString('hex'));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return out.join(' ');
    }
    /**
     * Format the stack as bitcoind asm.
     * @param {Boolean?} decode - Attempt to decode hash types.
     * @returns {String} Human-readable script.
     */

  }, {
    key: "toASM",
    value: function toASM(decode) {
      var out = [];

      var _iterator2 = _createForOfIteratorHelper(this.items),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          out.push(common.toASM(item, decode));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return out.join(' ');
    }
    /**
     * Clone the stack.
     * @returns {Stack} Cloned stack.
     */

  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.items.slice());
    }
    /**
     * Clear the stack.
     * @returns {Stack}
     */

  }, {
    key: "clear",
    value: function clear() {
      this.items.length = 0;
      return this;
    }
    /**
     * Get a stack item by index.
     * @param {Number} index
     * @returns {Buffer|null}
     */

  }, {
    key: "get",
    value: function get(index) {
      if (index < 0) index += this.items.length;
      if (index < 0 || index >= this.items.length) return null;
      return this.items[index];
    }
    /**
     * Pop a stack item.
     * @see Array#pop
     * @returns {Buffer|null}
     */

  }, {
    key: "pop",
    value: function pop() {
      var item = this.items.pop();
      return item || null;
    }
    /**
     * Shift a stack item.
     * @see Array#shift
     * @returns {Buffer|null}
     */

  }, {
    key: "shift",
    value: function shift() {
      var item = this.items.shift();
      return item || null;
    }
    /**
     * Remove an item.
     * @param {Number} index
     * @returns {Buffer}
     */

  }, {
    key: "remove",
    value: function remove(index) {
      if (index < 0) index += this.items.length;
      if (index < 0 || index >= this.items.length) return null;
      var items = this.items.splice(index, 1);
      if (items.length === 0) return null;
      return items[0];
    }
    /**
     * Set stack item at index.
     * @param {Number} index
     * @param {Buffer} value
     * @returns {Buffer}
     */

  }, {
    key: "set",
    value: function set(index, item) {
      if (index < 0) index += this.items.length;
      assert(Buffer.isBuffer(item));
      assert(index >= 0 && index <= this.items.length);
      this.items[index] = item;
      return this;
    }
    /**
     * Push item onto stack.
     * @see Array#push
     * @param {Buffer} item
     * @returns {Number} Stack size.
     */

  }, {
    key: "push",
    value: function push(item) {
      assert(Buffer.isBuffer(item));
      this.items.push(item);
      return this;
    }
    /**
     * Unshift item from stack.
     * @see Array#unshift
     * @param {Buffer} item
     * @returns {Number}
     */

  }, {
    key: "unshift",
    value: function unshift(item) {
      assert(Buffer.isBuffer(item));
      this.items.unshift(item);
      return this;
    }
    /**
     * Insert an item.
     * @param {Number} index
     * @param {Buffer} item
     * @returns {Buffer}
     */

  }, {
    key: "insert",
    value: function insert(index, item) {
      if (index < 0) index += this.items.length;
      assert(Buffer.isBuffer(item));
      assert(index >= 0 && index <= this.items.length);
      this.items.splice(index, 0, item);
      return this;
    }
    /**
     * Erase stack items.
     * @param {Number} start
     * @param {Number} end
     * @returns {Buffer[]}
     */

  }, {
    key: "erase",
    value: function erase(start, end) {
      if (start < 0) start = this.items.length + start;
      if (end < 0) end = this.items.length + end;
      this.items.splice(start, end - start);
    }
    /**
     * Swap stack values.
     * @param {Number} i1 - Index 1.
     * @param {Number} i2 - Index 2.
     */

  }, {
    key: "swap",
    value: function swap(i1, i2) {
      if (i1 < 0) i1 = this.items.length + i1;
      if (i2 < 0) i2 = this.items.length + i2;
      var v1 = this.items[i1];
      var v2 = this.items[i2];
      this.items[i1] = v2;
      this.items[i2] = v1;
    }
    /*
     * Data
     */

  }, {
    key: "getData",
    value: function getData(index) {
      return this.get(index);
    }
  }, {
    key: "popData",
    value: function popData() {
      return this.pop();
    }
  }, {
    key: "shiftData",
    value: function shiftData() {
      return this.shift();
    }
  }, {
    key: "removeData",
    value: function removeData(index) {
      return this.remove(index);
    }
  }, {
    key: "setData",
    value: function setData(index, data) {
      return this.set(index, data);
    }
  }, {
    key: "pushData",
    value: function pushData(data) {
      return this.push(data);
    }
  }, {
    key: "unshiftData",
    value: function unshiftData(data) {
      return this.unshift(data);
    }
  }, {
    key: "insertData",
    value: function insertData(index, data) {
      return this.insert(index, data);
    }
    /*
     * Length
     */

  }, {
    key: "getLength",
    value: function getLength(index) {
      var item = this.get(index);
      return item ? item.length : -1;
    }
    /*
     * String
     */

  }, {
    key: "getString",
    value: function getString(index, enc) {
      var item = this.get(index);
      return item ? Stack.toString(item, enc) : null;
    }
  }, {
    key: "popString",
    value: function popString(enc) {
      var item = this.pop();
      return item ? Stack.toString(item, enc) : null;
    }
  }, {
    key: "shiftString",
    value: function shiftString(enc) {
      var item = this.shift();
      return item ? Stack.toString(item, enc) : null;
    }
  }, {
    key: "removeString",
    value: function removeString(index, enc) {
      var item = this.remove(index);
      return item ? Stack.toString(item, enc) : null;
    }
  }, {
    key: "setString",
    value: function setString(index, str, enc) {
      return this.set(index, Stack.fromString(str, enc));
    }
  }, {
    key: "pushString",
    value: function pushString(str, enc) {
      return this.push(Stack.fromString(str, enc));
    }
  }, {
    key: "unshiftString",
    value: function unshiftString(str, enc) {
      return this.unshift(Stack.fromString(str, enc));
    }
  }, {
    key: "insertString",
    value: function insertString(index, str, enc) {
      return this.insert(index, Stack.fromString(str, enc));
    }
    /*
     * Num
     */

  }, {
    key: "getNum",
    value: function getNum(index, minimal, limit) {
      var item = this.get(index);
      return item ? Stack.toNum(item, minimal, limit) : null;
    }
  }, {
    key: "popNum",
    value: function popNum(minimal, limit) {
      var item = this.pop();
      return item ? Stack.toNum(item, minimal, limit) : null;
    }
  }, {
    key: "shiftNum",
    value: function shiftNum(minimal, limit) {
      var item = this.shift();
      return item ? Stack.toNum(item, minimal, limit) : null;
    }
  }, {
    key: "removeNum",
    value: function removeNum(index, minimal, limit) {
      var item = this.remove(index);
      return item ? Stack.toNum(item, minimal, limit) : null;
    }
  }, {
    key: "setNum",
    value: function setNum(index, num) {
      return this.set(index, Stack.fromNum(num));
    }
  }, {
    key: "pushNum",
    value: function pushNum(num) {
      return this.push(Stack.fromNum(num));
    }
  }, {
    key: "unshiftNum",
    value: function unshiftNum(num) {
      return this.unshift(Stack.fromNum(num));
    }
  }, {
    key: "insertNum",
    value: function insertNum(index, num) {
      return this.insert(index, Stack.fromNum(num));
    }
    /*
     * Int
     */

  }, {
    key: "getInt",
    value: function getInt(index, minimal, limit) {
      var item = this.get(index);
      return item ? Stack.toInt(item, minimal, limit) : -1;
    }
  }, {
    key: "popInt",
    value: function popInt(minimal, limit) {
      var item = this.pop();
      return item ? Stack.toInt(item, minimal, limit) : -1;
    }
  }, {
    key: "shiftInt",
    value: function shiftInt(minimal, limit) {
      var item = this.shift();
      return item ? Stack.toInt(item, minimal, limit) : -1;
    }
  }, {
    key: "removeInt",
    value: function removeInt(index, minimal, limit) {
      var item = this.remove(index);
      return item ? Stack.toInt(item, minimal, limit) : -1;
    }
  }, {
    key: "setInt",
    value: function setInt(index, num) {
      return this.set(index, Stack.fromInt(num));
    }
  }, {
    key: "pushInt",
    value: function pushInt(num) {
      return this.push(Stack.fromInt(num));
    }
  }, {
    key: "unshiftInt",
    value: function unshiftInt(num) {
      return this.unshift(Stack.fromInt(num));
    }
  }, {
    key: "insertInt",
    value: function insertInt(index, num) {
      return this.insert(index, Stack.fromInt(num));
    }
    /*
     * Bool
     */

  }, {
    key: "getBool",
    value: function getBool(index) {
      var item = this.get(index);
      return item ? Stack.toBool(item) : false;
    }
  }, {
    key: "popBool",
    value: function popBool() {
      var item = this.pop();
      return item ? Stack.toBool(item) : false;
    }
  }, {
    key: "shiftBool",
    value: function shiftBool() {
      var item = this.shift();
      return item ? Stack.toBool(item) : false;
    }
  }, {
    key: "removeBool",
    value: function removeBool(index) {
      var item = this.remove(index);
      return item ? Stack.toBool(item) : false;
    }
  }, {
    key: "setBool",
    value: function setBool(index, value) {
      return this.set(index, Stack.fromBool(value));
    }
  }, {
    key: "pushBool",
    value: function pushBool(value) {
      return this.push(Stack.fromBool(value));
    }
  }, {
    key: "unshiftBool",
    value: function unshiftBool(value) {
      return this.unshift(Stack.fromBool(value));
    }
  }, {
    key: "insertBool",
    value: function insertBool(index, value) {
      return this.insert(index, Stack.fromBool(value));
    }
    /**
     * Test an object to see if it is a Stack.
     * @param {Object} obj
     * @returns {Boolean}
     */

  }, {
    key: "length",
    get: function get() {
      return this.items.length;
    }
    /**
     * Set length.
     * @param {Number} value
     */
    ,
    set: function set(value) {
      this.items.length = value;
    }
  }], [{
    key: "isStack",
    value: function isStack(obj) {
      return obj instanceof Stack;
    }
    /*
     * Encoding
     */

  }, {
    key: "toString",
    value: function toString(item, enc) {
      assert(Buffer.isBuffer(item));
      return item.toString(enc || 'utf8');
    }
  }, {
    key: "fromString",
    value: function fromString(str, enc) {
      assert(typeof str === 'string');
      return Buffer.from(str, enc || 'utf8');
    }
  }, {
    key: "toNum",
    value: function toNum(item, minimal, limit) {
      return ScriptNum.decode(item, minimal, limit);
    }
  }, {
    key: "fromNum",
    value: function fromNum(num) {
      assert(ScriptNum.isScriptNum(num));
      return num.encode();
    }
  }, {
    key: "toInt",
    value: function toInt(item, minimal, limit) {
      var num = Stack.toNum(item, minimal, limit);
      return num.getInt();
    }
  }, {
    key: "fromInt",
    value: function fromInt(int) {
      assert(typeof int === 'number');
      if (int >= -1 && int <= 16) return common.small[int + 1];
      var num = ScriptNum.fromNumber(int);
      return Stack.fromNum(num);
    }
  }, {
    key: "toBool",
    value: function toBool(item) {
      assert(Buffer.isBuffer(item));

      for (var i = 0; i < item.length; i++) {
        if (item[i] !== 0) {
          // Cannot be negative zero
          if (i === item.length - 1 && item[i] === 0x80) return false;
          return true;
        }
      }

      return false;
    }
  }, {
    key: "fromBool",
    value: function fromBool(value) {
      assert(typeof value === 'boolean');
      return Stack.fromInt(value ? 1 : 0);
    }
  }]);

  return Stack;
}();
/*
 * Expose
 */


module.exports = Stack;